import initialState from './initialState'

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'UPDATE_INFO_BOX':
      return action.info_box
    case 'RESET_INFO_BOX':
      return initialState
    default:
      return state
  }
}

export default reducer
